<template>
    <div class="cata-body">
        <div class="cata-top">
            <backindex :msg="cataMsg"></backindex>
        </div>
        <div class="all-chapter">
            <div class="chapeter-title">{{$t("total")}}{{pageInfo.count}}{{$t("chapter")}}</div>
            <div class="chapeter-order">
                <img src="../assets/imgs/order.png" alt="" @click="changeOrder">
                <span>{{orderFonts}}</span>
            </div>
        </div>
        <ul class="chapeter-area">
            <li v-if="itemList.length==0" class="loading">
                {{$t("loading")}}
            </li>
            <li class="chapter-item" v-for="(item,index) in itemList" :key="index" @click="goRead(item.id)">
                <p class="chapter-name">{{item.title}}</p>
                <div class="chapter-free" v-if="parseInt(item.chapter)<item_start">{{$t("free")}}</div>
                <div class="chapter-free" v-if="parseInt(item.chapter)>=item_start">{{$t("coin")}}：{{item_coin}}</div>
            </li>
        </ul>
            <!--分{{$t("page")}}选择器-->
         <div class="change-page">
            <div :class="{'up-page':true,'down-page':upFlag,}" @click="upPage">上一{{$t("page")}}</div>
            <div class="select-view">
                <div class="select-page"   @click="showSelect">
                    <span>{{$t("第")}}{{page}}/{{pageInfo.totalPage}}{{$t("page")}}</span>
                    <img :class="{'select-img':showPage}" src="../assets/imgs/page-show.png" alt="">
                </div>
                <ul :class="{'select-area':true,'show-select':showPage}">
                    <li v-for="item in pageInfo.totalPage" :key="item" :class="{'page-item':page == item,}" @click="changePage(item)" >{{$t("第")}}{{item}}/{{pageInfo.totalPage}}{{$t("page")}}</li>
                </ul>
            </div>

            <div :class="{'down-page':true,'cant-down':!downFlag,}" @click="downPage">{{$t("nextPage")}}</div>
        </div>
        <pagebottom></pagebottom>
    </div>
</template>

<script>
import backindex from "@/components/common/backindex";
import pagebottom from "@/components/common/pagebottom";
export default {
  name: "catalog",
  components: {
    backindex,
    pagebottom
  },
  data() {
    return {
      //给顶部组件传值
      cataMsg: "目录",
      //正序 倒序
      orderFonts: "正序",
      order: true,
      //分{{$t("page")}}器 相关
      upFlag: false,
      downFlag: true,
      showPage: false,
      page: 1,
      id: this.$route.query.id,
      pageInfo: {},
      item_start: 0,
      item_coin: 0,
      itemList: []
    };
  },
  mounted: function() {
    this.getList();
  },
  methods: {
    /**
     * 目录列表
     */
    getList() {
      this.$indicator.open({
        text: "Loading...",
        spinnerType: "fading-circle"
      });
      this.req.itemList(this.id, this.page, this.order).then(res => {
        this.$indicator.close();
        if (res.status == 1) {
          this.item_start = res.data.item_start;
          this.item_coin = res.data.item_coin;
          this.itemList = res.data.list.list;
          this.pageInfo = res.data.list.pageInfo;
          console.info(this.pageInfo);
        } else {
          //todo
        }
      });
    },

    /**
     * 阅读指定{{$t("chapter")}}节
     */
    goRead(id) {
      this.go.goRead(id);
    },

    //改变排序
    changeOrder() {
      this.order = !this.order;
      if (this.order) {
        this.orderFonts = "正序";
      } else {
        this.orderFonts = "倒序";
      }
      this.getList();
    },
    //    改变{{$t("page")}}数
    changePage(page) {
      this.page = page;
      this.showPage = !this.showPage;
      this.getList();
    },
    showSelect() {
      this.showPage = !this.showPage;
    },
    //上一{{$t("page")}}
    upPage() {
      if (this.page == 1) return;
      this.page--;
      if (this.page == 1) {
        this.upFlag = false;
      } else {
        this.upFlag = true;
      }
      this.downFlag = true;
      this.getList();
    },
    //下一{{$t("page")}}
    downPage() {
      if (this.page == this.pageInfo.totalPage) return;
      this.page++;
      if (this.page == this.pageInfo.totalPage) {
        this.downFlag = false;
      } else {
        this.downFlag = true;
      }
      this.upFlag = true;
      this.getList();
    }
  }
};
</script>

<style scoped>
.loading {
  width: 100%;
  box-sizing: border-box;
  font-size: 0.3rem;
  text-align: center;
  padding: 3rem 0;
}
.cata-top {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
}
.all-chapter {
  width: 100%;
  height: 0.8rem;
  margin-top: 1.12rem;
  background: #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.4rem;
  box-sizing: border-box;
}
.chapeter-title {
  font-size: 0.26rem;
  line-height: 0.26rem;
  color: #999999;
  font-weight: 700;
}
.chapeter-order {
  display: flex;
  align-items: center;
}
.chapeter-order img {
  width: 0.48rem;
  height: 0.3rem;
  display: block;
}
.chapeter-order span {
  padding-left: 0.2rem;
  font-size: 0.24rem;
  line-height: 0.24rem;
  color: #ff1f4f;
}
.chapeter-area {
  width: 100%;
  height: auto;
}
.chapter-item {
  width: 100%;
  height: 0.85rem;
  border-bottom: 0.02rem solid #e6e6e6;
  padding: 0 0.4rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chapter-name,
.chapter-free {
  font-size: 0.22rem;
  line-height: 0.22rem;
}

.change-page {
  width: 100%;
  height: auto;
  padding: 0.6rem 0.3rem 0.8rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.up-page,
.down-page {
  width: 1.4rem;
  height: 0.62rem;
  box-sizing: border-box;
  font-size: 0.26rem;
  line-height: 0.62rem;
  border-radius: 0.06rem;
  text-align: center;
  font-weight: 700;
}
.up-page {
  border: 0.01rem solid #808080;
  color: #808080;
}
.down-page {
  border: 0.01rem solid #ff1f4f;
  color: #ff1f4f;
}
.cant-down {
  border: 0.01rem solid #808080;
  color: #808080;
}
/*分{{$t("page")}}器*/
.select-view {
  width: 2.9rem;
  height: 0.62rem;
  position: relative;
  font-size: 0.26rem;
  line-height: 0.62rem;
  color: #ff1f4f;
  text-align: center;
}
.select-page {
  width: 2.9rem;
  height: 0.62rem;
  box-sizing: border-box;
  border-radius: 0.06rem;
  border: 0.01rem solid #ff1f4f;
}
.select-page img {
  display: inline-block;
  width: 0.3rem;
  height: 0.18rem;
}
.select-img {
  transform: rotateX(180deg);
  animation: rotate 0.8s;
}
/*旋转动画*/
@keyframes rotate {
  from {
    transform: rotateX(0deg);
  }
  to {
    transform: rotateX(180deg);
  }
}
.select-page span {
  padding-right: 0.4rem;
  font-weight: 700;
}
.select-area {
  width: 2.9rem;
  height: 0;
  background: #ffffff;
  border: 0.01rem solid #ff1f4f;
  border-top: none;
  box-sizing: border-box;
  position: absolute;
  left: -0.01rem;
  top: 0.62rem;
  border-radius: 0 0 0.06rem 0.06rem;
  overflow-y: auto;
  opacity: 0;
}
.show-select {
  height: 2rem;
  opacity: 1;
  animation: show 0.8s;
}
/*下拉展示动画*/
@keyframes show {
  from {
    opacity: 0;
    height: 0;
  }
  to {
    opacity: 1;
    height: 2rem;
  }
}
.page-item {
  background: #f2f2f2;
}
</style>


// WEBPACK FOOTER //
// src/components/catalog.vue